const getGoToStep = (action) => {
  if (action.type === 'goToStep') {
    return action.step
  } else {
    for (const k in action) {
      if (k && typeof action[k] === 'object' && !Array.isArray(k)) {
        const goToStep = getGoToStep(action[k])

        if (!goToStep) {
          continue
        }

        return goToStep
      }
    }
  }
}

export const findgoToStep = (action = {}) => {
  return getGoToStep(action)
}
